import $ from 'jquery'
import _ from 'lodash'
import store from 'store2'
import slug from 'slug'
import fuse from 'fuse.js'

import * as auth from './lib/auth'

import guid from './lib/guid'
import log from './lib/log'

import admin from './view/admin/admin'
import frontend from './view/frontend/frontend'

console.log("OPEN MEMORY BOX v1.2")

slug.defaults.mode ='pretty'

slug.defaults.modes['pretty'] = {
  replacement: '-',
  symbols: true,
  remove: /[.]/g,
  lower: true,
  charmap: slug.charmap,
  multicharmap: slug.multicharmap,
}

window.$ = $
window._ = _
window.Slug = slug
window.Fuse = fuse

window.Config = require('../config')

var isTouch = function() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

var o = window.app = {
  store: store.namespace('omb'),
  isTouch: isTouch(),
  log: log,
  colors: {
    red: '#FB4820',
    yellow: '#E4D628',
  },
}

if(Config.resolutions[1080]){
  window.MaxResolution = 1080
} else if (Config.resolutions[720]){
  window.MaxResolution = 720
} else if (Config.resolutions[480]){
  window.MaxResolution = 480
} else {
  window.MaxResolution = 360
}

var start = function(){
  if(location.pathname == '/admin'){
    auth.validate(function(error){
      if(error){
        window.location.replace('/login')
        frontend(o)
      } else {
        admin()
      }
    })
  } else {
    frontend(o)
  }
}

var setLang = function(lang){
  lang = lang.toLowerCase()
  var isEn = _.includes(lang, 'en')
  var isFr = _.includes(lang, 'fr')
  var isRu = _.includes(lang, 'ru')
  if(isEn){
    o.store('lang','en')
  } else if(isFr){
    o.store('lang','fr')
  } else if(isRu){
    o.store('lang','ru')
  } else {
    o.store('lang','de')
  }
}

var calcLang = function(done){
  $.ajax({
    url: "http://ajaxhttpheaders.appspot.com", 
    dataType: 'jsonp', 
    success: function(headers) {
        var httpLang = headers['Accept-Language']
        console.log(httpLang);
        setLang(httpLang)
        done();
    },
    error: function(){
      var userLang = (navigator.language || navigator.userLanguage).toLowerCase()
      console.log(userLang)
      setLang(userLang)
      done()
    }
  })
}

$(document).ready(function() {
  
  console.log('document ready')
  console.log('init router', location.pathname);

  if(!o.store('userMarkers')){
    o.store('userMarkers',[])
  }

  if(!o.store('userId')){
    o.store('userId',guid())
  }

  if(!o.store('dataServer')){
    o.store('dataServer', Config.server.data)
  }

  if(!o.store('frontendServer')){
    o.store('frontendServer', Config.server.frontend)
  }

  if(!o.store('thumbServer')){
    o.store('thumbServer', Config.server.thumb)
  }

  if(!o.store('videoServer')){
    o.store('videoServer', Config.server.video)
  }

  if(!o.store('assetServer')){
    o.store('assetServer', Config.server.asset)
  }
  
  if(!o.store('subServer')){
    o.store('subServer', Config.server.thumb)
  }
  
  if(!o.store('fileServer')){
    o.store('fileServer', Config.server.file)
  }
  
  if(!o.store('soundServer')){
    o.store('soundServer', Config.server.sound)
  }

  if(Config.keyCdn.active){
    Config.server.thumb = Config.keyCdn.url
    Config.server.asset = Config.keyCdn.url
    Config.server.thumb = Config.keyCdn.url
  }

  if(!o.store('lang')){
    calcLang(start)
  } else {
    start()
  }

})



// WEBPACK FOOTER //
// ./src/client/app.js